export default __webpack_public_path__ + "static/media/serviceimg.58656eff.gif";